<div class="dashboard">
  <div class="p-grid dashboard-grid">
    <div class="p-col-12 p-lg-12 pageheader">
      <div class="fl-right">
        <button
          type="button"
          pButton
          (click)="export()"
          class="ui-button-success csv-export">
          <i class="mdl2-excel"></i> Export to CSV
          @if (excelLoading) {
            <i class="fa fa-spinner fa-spin"></i>
          }
        </button>
      </div>
    </div>

    <div class="p-col-12 p-lg-12">
      @if (loading) {
        <div class="loading-indicator">
          <p-progressSpinner></p-progressSpinner>
        </div>
      }
      <div class="inventory card">
        <p-table
          #dt
          [columns]="scrollableCols"
          [value]="pmos"
          selectionMode="single"
          [loadingIcon]="loadingIcon"
          [showLoader]="true"
          [scrollable]="true"
          [style]="{ width: '100%' }"
          scrollHeight="500px"
          dataKey="m365eventId"
          [paginator]="true"
          [rows]="dataViewRecsPerPage"
          [pageLinks]="pageLinksPerPage"
          paginatorPosition="top"
          [lazy]="true"
          (onLazyLoad)="loadSearchContent($any($event))"
          (onPage)="pageChange()"
          [totalRecords]="totalRecords"
          exportFilename="M365EventRecords">
          <ng-template pTemplate="caption">
            <div style="text-align: left">
              <div class="search-box-container">
                <div class="search-box mr-2">
                  <input
                    type="text"
                    pInputText
                    size="30"
                    placeholder="Search"
                    (input)="searchOrFilterEngagements()"
                    style="width: 340px"
                    [(ngModel)]="searchAndFilterInput.searchString" />
                </div>
                @if (searchAndFilterInput.searchString) {
                  <button
                    pButton
                    pRipple
                    type="button"
                    icon="pi pi-times"
                    (click)="clearSearchText()"
                    class="close-button p-button-rounded p-button-text p-0">
                    Clear
                  </button>
                }
                <i class="fa fa-search ml-2"></i>
                <span class="pageInfo visiblelg resettble">{{
                  currentPageInfo
                }}</span>
              </div>
              <span style="float: right; position: relative; bottom: 24px"
                ><a (click)="reset()" (keydown.enter)="reset()" tabindex="0"
                  ><span class="fa fa-repeat"></span> Reset table</a
                ></span
              >
            </div>
          </ng-template>
          <ng-template #header let-columns>
            <tr>
              <th [pSortableColumn]="'EngagementKey'" class="colsmall">
                Activity Key<p-sortIcon [field]="'engagementKey'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'TaskOwner'" class="colsmall">
                Task Owner<p-sortIcon [field]="'taskOwner'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'Status'" class="colmedium">
                Activity Status<p-sortIcon [field]="'status'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'L1InternalStatus'" class="colsmall">
                L1InternalStatus<p-sortIcon
                  [field]="'l1InternalStatus'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'PoeStatus'" class="colsmall">
                POE Status<p-sortIcon [field]="'poeStatus'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'RequestDate'" class="colmedium">
                Request Date<p-sortIcon [field]="'requestDate'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'EngagementSubType'" class="colmedium">
                Activity Sub Type<p-sortIcon
                  [field]="'engagementSubType'"></p-sortIcon>
              </th>
              <th
                [pSortableColumn]="'PartnerInputParnterName'"
                class="colmedium">
                Partner Name<p-sortIcon
                  [field]="'partnerInputParnterName'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'PartnerInputMPNId'" class="colsmall">
                PartnerID<p-sortIcon [field]="'partnerInputMPNId'"></p-sortIcon>
              </th>
              <th
                [pSortableColumn]="'PartnerInputCustomerTPId'"
                class="colsmall">
                TPID<p-sortIcon
                  [field]="'partnerInputCustomerTPId'"></p-sortIcon>
              </th>
              <th
                [pSortableColumn]="'PartnerInputCustomerTenantId'"
                class="colmedium">
                Customer Tenant ID<p-sortIcon
                  [field]="'partnerInputCustomerTenantId'"></p-sortIcon>
              </th>
              <th
                [pSortableColumn]="'PartnerInputCustomerDomainName'"
                class="colmedium">
                Domain Name<p-sortIcon
                  [field]="'partnerInputCustomerDomainName'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'RequestID'" class="colmedium">
                Request ID<p-sortIcon [field]="'requestID'"></p-sortIcon>
              </th>
            </tr>
            <tr>
              <th class="dashtable colsmall">
                <input
                  pInputText
                  type="text"
                  (input)="searchOrFilterEngagements()"
                  [(ngModel)]="searchAndFilterInput.engagementKey" />
              </th>
              <th class="dashtable colsmall">
                <p-multiSelect
                  [options]="ftaskOwnerDrpdwn"
                  #tak
                  appendTo="body"
                  placeholder="Task Owner"
                  [(ngModel)]="searchAndFilterInput.taskOwners"
                  (onChange)="searchOrFilterEngagements()"></p-multiSelect>
              </th>
              <th class="dashtable colmedium">
                <input
                  pInputText
                  type="text"
                  (input)="searchOrFilterEngagements()"
                  [(ngModel)]="searchAndFilterInput.status" />
              </th>
              <th class="dashtable colsmall">
                <p-multiSelect
                  [options]="fl1InternalStatusDrpdwn"
                  #tak
                  appendTo="body"
                  placeholder="L1InternalStatus"
                  [(ngModel)]="searchAndFilterInput.l1InternalStatuses"
                  (onChange)="searchOrFilterEngagements()"></p-multiSelect>
              </th>
              <th class="dashtable colsmall">
                <p-multiSelect
                  #tak
                  appendTo="body"
                  [options]="poeStatusDrpdwn"
                  placeholder="POE Status"
                  [(ngModel)]="searchAndFilterInput.poeStatuses"
                  (onChange)="searchOrFilterEngagements()"></p-multiSelect>
              </th>
              <th class="dashtable colmedium">
                <input
                  pInputText
                  type="text"
                  (input)="searchOrFilterEngagements()"
                  [(ngModel)]="searchAndFilterInput.requestDate" />
              </th>
              <th class="dashtable colmedium">
                <input
                  pInputText
                  type="text"
                  (input)="searchOrFilterEngagements()"
                  [(ngModel)]="searchAndFilterInput.engagementSubType" />
              </th>
              <th class="dashtable colmedium">
                <input
                  pInputText
                  type="text"
                  (input)="searchOrFilterEngagements()"
                  [(ngModel)]="searchAndFilterInput.partnerInputParnterName" />
              </th>
              <th class="dashtable colsmall">
                <input
                  pInputText
                  type="text"
                  (input)="searchOrFilterEngagements()"
                  [(ngModel)]="searchAndFilterInput.partnerInputMPNId" />
              </th>
              <th class="dashtable colsmall">
                <input
                  pInputText
                  type="text"
                  (input)="searchOrFilterEngagements()"
                  [(ngModel)]="searchAndFilterInput.partnerInputCustomerTPId" />
              </th>
              <th class="dashtable colmedium">
                <input
                  pInputText
                  type="text"
                  (input)="searchOrFilterEngagements()"
                  [(ngModel)]="
                    searchAndFilterInput.partnerInputCustomerTenantId
                  " />
              </th>
              <th class="dashtable colmedium">
                <input
                  pInputText
                  type="text"
                  (input)="searchOrFilterEngagements()"
                  [(ngModel)]="
                    searchAndFilterInput.partnerInputCustomerDomainName
                  " />
              </th>
              <th class="dashtable colmedium">
                <input
                  pInputText
                  type="text"
                  (input)="searchOrFilterEngagements()"
                  [(ngModel)]="searchAndFilterInput.requestID" />
              </th>
            </tr>
          </ng-template>
          <ng-template #body let-rowData let-columns="columns">
            <tr (dblclick)="editRequestDetails(rowData.engagementKey)">
              <td class="colsmall">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.engagementKey }}"
                  ><a
                    (click)="editRequestDetails(rowData.engagementKey)"
                    (keydown.enter)="editRequestDetails(rowData.engagementKey)"
                    tabindex="0"
                    class="editlink"
                    >{{ rowData.engagementKey }}</a
                  ></span
                >
              </td>
              <td class="colsmall">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.engagementKey }} : {{
                    rowData.taskOwner
                  }}"
                  >{{ rowData.taskOwner }}</span
                >
              </td>
              <td class="colmedium">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.engagementKey }} : {{ rowData.status }}"
                  >{{ rowData.status }}</span
                >
              </td>
              <td class="colsmall">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.engagementKey }} : {{
                    rowData.l1InternalStatus
                  }}"
                  >{{ rowData.l1InternalStatus }}</span
                >
              </td>
              <td class="colsmall">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.engagementKey }} : {{
                    rowData.poeStatus
                  }}"
                  >{{ rowData.poeStatus }}</span
                >
              </td>
              <td class="colmedium">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.engagementKey }} : {{
                    rowData.requestDate
                  }}"
                  >{{ rowData.requestDate }}</span
                >
              </td>
              <td class="colmedium">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.engagementKey }} : {{
                    rowData.engagementSubType
                  }}"
                  >{{ rowData.engagementSubType }}</span
                >
              </td>
              <td class="colmedium">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.engagementKey }} : {{
                    rowData.partnerInputParnterName
                  }}"
                  >{{ rowData.partnerInputParnterName }}</span
                >
              </td>
              <td class="colsmall">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.engagementKey }} : {{
                    rowData.partnerInputMPNId
                  }}"
                  ><a
                    (click)="redirectToPartner(rowData.partnerInputMPNId)"
                    (keydown.enter)="
                      redirectToPartner(rowData.partnerInputMPNId)
                    "
                    tabindex="0"
                    class="editlink"
                    >{{ rowData.partnerInputMPNId }}</a
                  ></span
                >
              </td>
              <td class="colsmall">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.engagementKey }} : {{
                    rowData.partnerInputCustomerTPId
                  }}"
                  >{{ rowData.partnerInputCustomerTPId }}</span
                >
              </td>
              <td class="colmedium">
                <span class="tenantId-copy">
                  <div
                    class="tenantId"
                    tooltipPosition="top"
                    pTooltip="{{ rowData.engagementKey }} : {{
                      rowData.partnerInputCustomerTenantId
                    }}">
                    {{ rowData.partnerInputCustomerTenantId }}
                  </div>
                  <div
                    tabindex="0"
                    id="tenantIdDetail"
                    class="tooltip-style mdl2-copy email-copy"
                    (mouseenter)="setFocus()"
                    (mouseleave)="setFocusout()"
                    (keyup.enter)="
                      copyText(rowData.partnerInputCustomerTenantId)
                    "
                    (click)="copyText(rowData.partnerInputCustomerTenantId)">
                    @if (showToolTip) {
                      <span>
                        @if (!copiedDetails) {
                          <span class="tooltiptext-copy">
                            <span>Copy to clipboard</span>
                          </span>
                        }
                        @if (copiedDetails) {
                          <span class="tooltiptext-copy-short">
                            <span>Copied!</span>
                          </span>
                        }
                      </span>
                    }
                  </div>
                </span>
              </td>
              <td class="colmedium">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.engagementKey }} : {{
                    rowData.partnerInputCustomerDomainName
                  }}"
                  >{{ rowData.partnerInputCustomerDomainName }}</span
                >
              </td>
              <td class="colmedium">
                <span
                  tooltipPosition="top"
                  pTooltip="{{ rowData.engagementKey }} : {{
                    rowData.requestID
                  }}"
                  >{{ rowData.requestID }}</span
                >
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>

@if (loadEditComponent) {
  <p-dialog
    id="engagementEdit"
    [transitionOptions]="'10ms'"
    [(visible)]="editNav"
    modal="true"
    showEffect="fade"
    [maximizable]="true"
    [style]="{ width: '90vw' }"
    (onHide)="onCloseEditModal()"
    [draggable]="false"
    [resizable]="false">
    <app-edit
      [engagementEditInput]="engagementEditInput"
      #editNavChild
      (refreshPartnerInput)="refresh()"
      (showFullscreen)="onShowFullScreenChanged($event)"
      (closeEditSidebar)="onCloseEditModal()"></app-edit>
  </p-dialog>
}
